$('.slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: false,
});
